module.exports = __webpack_public_path__ + "static/media/lock.242d659c.png";